import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService } from 'ng-jhipster';
import { AutorisationBnbaccess } from './autorisation-bnbaccess.model';
import { AutorisationBnbaccessService } from './autorisation-bnbaccess.service';

@Component({
    selector: 'jhi-autorisation-bnbaccess-detail',
    templateUrl: './autorisation-bnbaccess-detail.component.html'
})
export class AutorisationBnbaccessDetailComponent implements OnInit, OnDestroy {

    autorisation: AutorisationBnbaccess;
    private subscription: any;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private autorisationService: AutorisationBnbaccessService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['autorisation']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
    }

    load (id) {
        this.autorisationService.find(id).subscribe(autorisation => {
            this.autorisation = autorisation;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/autorisation/autorisation-bnbaccess-detail.component.ts